/**
 * Data management exported files service
 */
angular.module("exploitation").factory("OperatorsService", ["$http", "ENV", function ($http, ENV) {

	const RESSOURCE = "/operators";

	/**
     * API
     */
	let api = {
		getOperators: getOperators,
		getOperator: getOperator,
		edit: edit,
		addOperateur: addOperateur,
		deleteOperator: deleteOperator
	};

	/**
	 * Liste des opérators
	 * @returns {HttpPromise}
	 */
	function getOperators() {
		return $http.get(ENV.API_URL + RESSOURCE);
	}

	/**
	 * Un opérator
	 * @param operatorId
	 * @returns {HttpPromise}
	 */
	function getOperator(operatorId) {
		return $http.get(ENV.API_URL + RESSOURCE + "/" + operatorId);
	}

	/**
	 * Modifie un opérateur
	 */
	function edit(operator){
		return $http.put(ENV.API_URL + RESSOURCE +"/" + operator.id, operator);
	}

	/**
	 * Ajoute un opérateur
	 */
	function addOperateur(operator){
		return $http.post(ENV.API_URL + RESSOURCE, operator);
	}

	/**
	 * Supprimer un opérateur
	 */
	function deleteOperator(operatorId){
		return $http.delete(ENV.API_URL + RESSOURCE + "/" + operatorId);
	}


	return api;
}]);
